PageApp.Views.ContentView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.content,
  initialize: function () {
  }
})
